<template>
  <section class="app-container">
    <xp-topbar :platform-name="platformName" use-language></xp-topbar>
    <!-- <xp-sidebar
      :routes="routes"
      :collapse="isCollapse"
      @select="handleSelect"
    ></xp-sidebar> -->

    <div class="draggable-sidebar-container">
      <div class="sidebar" :style="{ width: sidebarWidth + 'px' }">
        <el-menu
          mode="vertical"
          v-bind="$attrs"
          :unique-opened="true"
          :default-active="$route.path"
          @select="handleSelect"
          :class="[{ 'el-menu--collapse': isCollapse }]"
          :collapseTransition="false"
        >
          <template v-for="item in routes">
            <template v-if="!item.hidden && item.children">
              <el-submenu
                popper-class="sidebar-submenu"
                :index="item.name || item.path"
                :key="item.name"
              >
                <template slot="title">
                  <icon
                    v-if="item.meta && item.meta.icon"
                    :name="item.meta.icon"
                  ></icon>
                  <span
                    v-if="item.meta && item.meta.title"
                    class="text-ellipsis"
                    :title="item.meta.title"
                    >{{ item.meta.title }}</span
                  >
                </template>

                <template v-for="child in item.children">
                  <template v-if="!child.hidden">
                    <sidebar-item
                      class="nest-menu"
                      v-if="child.children && child.children.length > 0"
                      :routes="[child]"
                      :key="child.path"
                    ></sidebar-item>

                    <router-link v-else :to="child.path" :key="child.name">
                      <el-menu-item
                        :index="child.path"
                        :class="{
                          'is-active': $route.path === child.path
                        }"
                        @click="handleMenuClick(child)"
                      >
                        <icon
                          v-if="child.meta && child.meta.icon"
                          :name="child.meta.icon"
                        ></icon>
                        <span
                          v-if="child.meta && child.meta.title"
                          class="text-ellipsis-2"
                          :title="child.meta.title"
                          >{{ child.meta.title }}</span
                        >
                      </el-menu-item>
                    </router-link>
                  </template>
                </template>
              </el-submenu>
            </template>
          </template>
        </el-menu>
      </div>
      <div
        class="drag-bar"
        :style="{ left: sidebarWidth + 'px' }"
        @mousedown="startDrag"
        @touchstart="startDrag"
      >
        <div class="drag-icon"></div>
      </div>
      <!-- 拖拽遮罩层（防止选中文本） -->
      <div
        v-if="isDragging"
        class="drag-mask"
        @mouseup="stopDrag"
        @mousemove="onDrag"
        @touchmove="onDrag"
        @touchend="stopDrag"
      ></div>
      <xp-content :left="sidebarWidth + 15"></xp-content>
    </div>
  </section>
</template>

<script>
import XpTopbar from '@xpeng/topbar'
import XpSidebar from '@xpeng/sidebar'
import XpContent from './content.vue'
import SidebarItem from './sidebar-item.vue'

import Config from '@/config'

export default {
  components: {
    XpTopbar,
    XpSidebar,
    XpContent,
    SidebarItem
  },
  data() {
    return {
      platformName: Config.PLATFORM_NAME,

      // 拖拽
      sidebarWidth: 200,
      isDragging: false,
      startX: 0,
      startWidth: 0,
      minWidth: 200,
      maxWidth: 500
    }
  },
  computed: {
    isCollapse() {
      return this.$store.state.sideBarCollapse
    },
    routes() {
      return this.$store.state.userMenus
    }
  },
  mounted() {
    const route = this.$route

    if (route.path !== '/') {
      const componentName =
        route.matched[route.matched.length - 1].components.default.name
      // 推入tab页
      this.$store.commit('pushNavPage', {
        name: route.meta.title,
        path: route.path,
        componentName: componentName
      })
    }
    this.initRouterGuards()

    // 初始化时从 localStorage 读取保存的宽度
    const savedWidth = localStorage.getItem('sidebarWidth')
    if (savedWidth) {
      this.sidebarWidth = parseInt(savedWidth)
    }
  },
  methods: {
    handleSelect(index) {
      setTimeout(() => this.pushNavPage(), 100)
    },
    // 动态推入页面栈
    pushNavPage(showTip = true) {
      const route = this.$route
      const matchedRoute = route.matched[route.matched.length - 1]
      const componentName = matchedRoute.components.default.name

      if (Config.MAX_NAV_LIST === 0) {
        return
      }
      // 打开页面太多
      if (
        showTip &&
        this.$store.state.navList.length > 8 &&
        this.isInNavList(componentName)
      ) {
        this.$notify.warning({
          title: '注意',
          dangerouslyUseHTMLString: true,
          message:
            '<h3 class="too-much-page-open-tip">打开页面过多会导致系统卡顿，请关闭暂时不用的页面<h3>'
        })
      }

      // 推入tab页
      this.$store.commit('pushNavPage', {
        name: route.meta.title,
        path: route.path,
        componentName
      })

      if (!componentName) {
        throw new Error('【error】请填写vue组件name属性！')
      } else {
        // 缓存当前tab页
        this.$store.commit('pushAliveComponent', componentName)
      }
    },
    initRouterGuards() {
      this.$router.afterEach((to, from) => {
        const matchedRoute = to.matched[to.matched.length - 1]
        const componentName = matchedRoute.components.default.name

        if (componentName === 'empty-page') {
          return
        }

        if (!this.isInNavList(componentName)) {
          this.pushNavPage(false)
        }
      })
    },
    isInNavList(componentName) {
      const index = this.$store.state.navList.findIndex((item) => {
        return componentName === item.componentName
      })

      return index !== -1
    },

    startDrag(event) {
      event.preventDefault()
      this.isDragging = true
      this.startX = event.clientX || event.touches[0].clientX
      this.startWidth = this.sidebarWidth

      // 防止文本选中
      document.body.style.userSelect = 'none'
      document.body.style.cursor = 'col-resize'
    },

    onDrag(event) {
      if (!this.isDragging) return

      event.preventDefault()
      const clientX = event.clientX || event.touches[0].clientX
      const deltaX = clientX - this.startX

      let newWidth = this.startWidth + deltaX

      // 限制宽度范围
      if (newWidth < this.minWidth) newWidth = this.minWidth
      if (newWidth > this.maxWidth) newWidth = this.maxWidth

      this.sidebarWidth = newWidth
    },

    stopDrag() {
      if (!this.isDragging) return

      this.isDragging = false

      // 保存到 localStorage
      localStorage.setItem('sidebarWidth', this.sidebarWidth.toString())

      // 恢复样式
      document.body.style.userSelect = ''
      document.body.style.cursor = ''
    },
    handleMenuClick(item) {
      this.$root.$emit('handleMenuClick', item)
    }
  },
  beforeDestroy() {
    // 清理事件监听
    document.body.style.userSelect = ''
    document.body.style.cursor = ''
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  height: 100%;
  background: #ffffff;
}

.draggable-sidebar-container {
  display: flex;
  height: calc(100% - 60px);
  overflow: hidden;
}

.too-much-page-open-tip {
  color: #f56c6c;
  font-weight: 500;
  font-size: 14px;
}

.sidebar {
  position: fixed;
  z-index: 101;
  top: 60px;
  left: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #373d41;
}

:deep .sidebar-submenu {
  background-color: #373d41;
}

.text-ellipsis {
  display: inline-block;
  width: 76%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-ellipsis-2 {
  @extend .text-ellipsis;
  width: 100%;
}

.drag-bar {
  position: fixed;
  top: 60px;
  bottom: 0;
  width: 15px;
  background: #dddddd;
  cursor: col-resize;
  z-index: 101;

  .drag-icon {
    position: absolute;
    top: calc(50% - 10px);
    left: 3px;
    width: 8px;
    height: 20px;
    border-left: solid 3px #666666;
    border-right: solid 3px #666666;
  }
}

.drag-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  cursor: col-resize;
}
</style>
